import { useQuery } from '@tanstack/react-query'
import { getBusinessInfo } from '../services/bookingsService'

export function useBookingBusiness() {
  return useQuery({
    queryKey: ['businessInfo'],
    queryFn: () => getBusinessInfo(),
    staleTime: 60 * 60 * 1000,
  })
}
